module.exports = __webpack_public_path__ + "img/Header_Desktop_Logo1.b0531009.png";